// eslint-disable-next-line
export default {
   'titles.partners': 'Socios',
   'titles.programs': 'Programas',
   'titles.operations': 'Operaciones',
   'titles.dashboard': 'Dashboard',
   'titles.settings': 'Configuración',
   'titles.toggleMenu': 'Mostrar u ocultar menú',
   'titles.collapseMenu': 'Colapsar menú',
   'titles.expandMenu': 'Expandir menú',
}
